var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1957_85702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 0H3C1.34315 0 0 1.34315 0 3V5.25C0 6.90685 1.34315 8.25 3 8.25H5.25C6.90685 8.25 8.25 6.90685 8.25 5.25V3C8.25 1.34315 6.90685 0 5.25 0Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.999 0H12.749C11.0922 0 9.74902 1.34315 9.74902 3V5.25C9.74902 6.90686 11.0922 8.25001 12.749 8.25001H14.999C16.6559 8.25001 17.999 6.90686 17.999 5.25V3C17.999 1.34315 16.6559 0 14.999 0Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9.75049H3C1.34315 9.75049 0 11.0936 0 12.7505V15.0005C0 16.6574 1.34315 18.0005 3 18.0005H5.25C6.90685 18.0005 8.25 16.6574 8.25 15.0005V12.7505C8.25 11.0936 6.90685 9.75049 5.25 9.75049Z",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.999 9.75049H12.749C11.0922 9.75049 9.74902 11.0936 9.74902 12.7505V15.0005C9.74902 16.6574 11.0922 18.0005 12.749 18.0005H14.999C16.6559 18.0005 17.999 16.6574 17.999 15.0005V12.7505C17.999 11.0936 16.6559 9.75049 14.999 9.75049Z",
    fill: "#404041"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1957_85702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.47673b234688f4cb7b5ac871370105bf.svg";
export { ForwardRef as ReactComponent };